import {createAction} from "redux-act";
import {IHelpReducer, IHelpSuccessPayload} from "modules/types/reducers";

export const fetchHelpRequest = createAction<keyof IHelpReducer>();
export const fetchHelpSuccess = createAction<IHelpSuccessPayload>();
